// partially from - https://github.com/joaocunha/modernizr-retina-test/blob/master/modernizr-retina-test.js
export function isRetina() {
    const dpr = window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI) || 1;

    return !!(dpr > 1);
}